// WordPress dependencies
import { TabPanel } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

// Internal dependencies
import ContentTab from "./tabs/ContentTab";
import StylesTab from "./tabs/StylesTab";
import PreviewTab from "./panels/PreviewTab";

const TabsList = [
    {
        name: "content",
        title: __("Content ", "wp-before-after-image-slider"),
        className: "tab-one-content",
    },
    {
        name: "styles",
        title: __("Styles ", "wp-before-after-image-slider"),
        className: "tab-two-styles",
    },
];

export default (props) => {
    // update parent attributes
    const updateAttributes = (stateOptions) => {
        const features = props.proFeatures;
        const isProFeature = props.proFeatureEnabled;

        // Create a single object with all updates
        const validUpdates = {};
        
        [].forEach.call(Object.entries(stateOptions), ([key, value]) => {
            if (features.includes(key) && !isProFeature) {
                return;
            }
            validUpdates[key] = value;
        });
        
        // Update all attributes at once
        if (Object.keys(validUpdates).length > 0) {
            props.updateAttributes(validUpdates);
        }
    };

    const renderTab = (tab) => {
        let ActiveTab = ContentTab;

        if (tab.name === "styles") {
            ActiveTab = StylesTab;
        }

        return <ActiveTab {...props} tabInfo={tab} updateAttributes={updateAttributes} />;
    };

    return (
        <div className="coca-bais-tabs-wrapper">
            <TabPanel
                className="coca-bais-panel"
                orientation="horizontal"
                tabs={TabsList}
                initialTabName={props.attributes.active_tab}
                selectOnMove={true}
                onSelect={(tabName) => {
                    updateAttributes({ active_tab: tabName });
                }}
            >
                {(tab) => renderTab(tab)}
            </TabPanel>
            <div className="coca-bais-preview-btn-wrapper">
                <PreviewTab attributes={props.attributes} />
            </div>
        </div>
    );
};
